var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBaloonBig = function SvgBaloonBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 72,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#38D9CE",
    d: "M2 34.65c.91-22 22.07-38.8 45.35-32.2a34.12 34.12 0 0 1 23.42 23.38 35.49 35.49 0 0 1-27 45.05c-.27.05-.64.13-.91.17-.773.128-1.556.192-2.34.19H3.72a3.71 3.71 0 0 1-2.78-6.17l1.18-1.35A7.45 7.45 0 0 0 3.92 60a10.1 10.1 0 0 0 0-4A88.8 88.8 0 0 1 2 34.67z"
  })));
};
export default SvgBaloonBig;